export default {
  restaurantdeals: {
    shop_by: "Shop By",
    category: "Category",
    popular_categories: "Popular Categories",
    loading: "Loading categories...",
    no_data: "No categories found",
  },
};